module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page5.1d35e5db.jpg";